import { css } from '@emotion/css';

import { BorderRadius, Font, TextAlign, Spacing, Display, AlignItems, ColorConstant } from '../../../styles';

export const alert = (type: 'success' | 'info' | 'warning' | 'error', condensed = false) => css`
  ${BorderRadius.xs}
  ${Spacing.p12}
  ${Spacing.m8}
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.04), 0px 0px 2px rgba(0, 0, 0, 0.06), 0px 0px 1px rgba(0, 0, 0, 0.35);
  border: none;
  ${Display.flex}
  ${AlignItems.center}
  background-color: ${type === 'error'
    ? ColorConstant.RED1
    : type === 'warning'
    ? ColorConstant.ORANGE1
    : type === 'info'
    ? ColorConstant.BRAND1
    : ColorConstant.GREEN1};

  .ant-alert-description {
    ${TextAlign.left}
    ${Font.lg}
  }

  ${condensed &&
  css`
    ${Spacing.ml0}
    ${Spacing.p8}

    .ant-alert-description {
      white-space: pre;
    }
  `}
`;

export const icon = (type: 'success' | 'info' | 'warning' | 'error') => css`
  color: ${type === 'error'
    ? ColorConstant.RED7
    : type === 'warning'
    ? ColorConstant.ORANGE6
    : type === 'info'
    ? ColorConstant.BRAND6
    : ColorConstant.GREEN6} !important;
`;
